import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';

const styles = {
  icon: { fill: "#343A40"}
}

const AppBarButton = ({ Icon, onClick, disabled, classes, className }) => (
  <IconButton onClick={onClick} disabled={disabled} className={className}>
    <Icon className={classes.icon}/>
  </IconButton>
)

export default withStyles(styles)(AppBarButton);